    // FAQ accordion
    document.querySelectorAll('.faq-q').forEach(q => {
      q.addEventListener('click', () => q.parentElement.classList.toggle('is-open'));
    });

    // Scrollspy
    const tocItems = document.querySelectorAll('.toc li');
    const sectionMap = new Map();
    tocItems.forEach(li => {
      const sec = document.getElementById(li.dataset.target);
      if (sec) sectionMap.set(li.dataset.target, { sec, li });
    });
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          tocItems.forEach(li => li.classList.remove('is-active'));
          const item = sectionMap.get(entry.target.id);
          if (item) item.li.classList.add('is-active');
        }
      });
    }, { rootMargin: '-40% 0px -55% 0px' });
    sectionMap.forEach(({ sec }) => observer.observe(sec));

    // Hide TOC when footer enters viewport
    const tocEl = document.querySelector('.toc');
    const footerEl = document.querySelector('.fathersday-footer-wrap');
    if (tocEl && footerEl) {
      const fObs = new IntersectionObserver(es => {
        es.forEach(e => tocEl.classList.toggle('toc-hidden', e.isIntersecting));
      }, { threshold: 0.01 });
      fObs.observe(footerEl);
    }

    // Variant selection per product card
    const formatMoney = (cents) => {
      const yen = Math.round(cents / 100);
      return '¥' + yen.toLocaleString('ja-JP');
    };

    document.querySelectorAll('.product[data-product-handle]').forEach(card => {
      const dataEl = card.querySelector('.js-variants-data');
      if (!dataEl) return;
      let variants = [];
      try { variants = JSON.parse(dataEl.textContent.trim()); } catch (e) { return; }
      const addBtn = card.querySelector('.js-add-to-cart');
      const priceEl = card.querySelector('.js-product-price');
      const selected = {};

      const findMatch = () => variants.find(v =>
        Object.entries(selected).every(([pos, val]) => v['option' + pos] === val)
      );

      const refresh = () => {
        const match = findMatch();
        if (addBtn) {
          if (match && match.available) {
            addBtn.dataset.variantId = match.id;
            addBtn.disabled = false;
            addBtn.textContent = 'カートに追加';
          } else if (match) {
            addBtn.dataset.variantId = match.id;
            addBtn.disabled = true;
            addBtn.textContent = '在庫切れ';
          } else {
            addBtn.disabled = true;
            addBtn.textContent = '組み合わせ無効';
          }
        }
        if (priceEl && match) {
          priceEl.textContent = formatMoney(match.price);
        }
      };

      card.querySelectorAll('.opt-group').forEach(group => {
        const pos = group.dataset.optPosition;
        const initial = group.querySelector('.opt-btn.is-selected') || group.querySelector('.opt-btn');
        if (initial) selected[pos] = initial.dataset.value;
        group.querySelectorAll('.opt-btn').forEach(btn => {
          btn.addEventListener('click', () => {
            group.querySelectorAll('.opt-btn').forEach(b => b.classList.remove('is-selected'));
            btn.classList.add('is-selected');
            selected[pos] = btn.dataset.value;
            refresh();
          });
        });
      });
      refresh();
    });

    // Add to cart handler (shared) — Horizon-compatible
    const collectSectionIds = () => {
      const ids = new Set();
      document.querySelectorAll('[data-section-id]').forEach(el => {
        const tag = el.tagName.toLowerCase();
        if (tag === 'cart-items-component' || tag === 'cart-icon-component' || tag === 'cart-drawer-component' || tag === 'cart-summary-component') {
          ids.add(el.dataset.sectionId);
        }
      });
      return Array.from(ids).filter(Boolean);
    };

    const dispatchCartUpdate = (cart, sourceId) => {
      const evt = new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: sourceId || 'fathersday-lp',
          data: {
            source: 'fathersday-lp',
            productId: cart.product_id ? String(cart.product_id) : undefined,
            itemCount: typeof cart.item_count === 'number' ? cart.item_count : (typeof cart.quantity === 'number' ? cart.quantity : undefined),
            variantId: cart.variant_id ? String(cart.variant_id) : undefined,
            sections: cart.sections || {}
          }
        }
      });
      document.dispatchEvent(evt);
    };

    const openCartDrawer = () => {
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      }
    };

    document.querySelectorAll('.js-add-to-cart').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        const id = btn.dataset.variantId;
        if (!id || btn.disabled) return;
        const original = btn.textContent;
        btn.disabled = true;
        btn.textContent = '追加中…';
        try {
          const sectionIds = collectSectionIds();
          const formData = new FormData();
          formData.append('id', String(parseInt(id, 10)));
          formData.append('quantity', '1');
          if (sectionIds.length) formData.append('sections', sectionIds.join(','));

          const addRes = await fetch('/cart/add', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: formData
          });
          if (!addRes.ok) {
            const err = await addRes.json().catch(() => ({}));
            throw new Error(err.description || err.message || '追加失敗');
          }
          const addedItem = await addRes.json();

          // Fetch full cart to get accurate item_count and sections fallback
          const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
          const cart = cartRes.ok ? await cartRes.json() : {};

          dispatchCartUpdate({
            ...addedItem,
            item_count: cart.item_count,
            sections: addedItem.sections || {}
          });

          openCartDrawer();
          btn.textContent = '追加しました ✓';
          setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1800);
        } catch (err) {
          console.error('Cart add failed', err);
          btn.textContent = 'エラー、再試行';
          setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 2000);
        }
      });
    });
